import(/* webpackMode: "eager", webpackExports: ["LoginPage"] */ "/app/apps/royalur/src/app/(auth)/login/LoginPage.tsx");
